import React, { ReactElement } from "react";
import Layout from "../../components/layout";
import TimeSlotList from "../../components/TimeSlot";

const TimeSlotPage = (): ReactElement => {
  return (
    <Layout>
      <TimeSlotList />
    </Layout>
  );
};

export default TimeSlotPage;
